import React, { Component } from "react";
// ce fichier est appelé par Deducer, et va servir à créer les boutons relatifs à la déduction en cours :
// a) le bouton pour activer/désactiver la détection des inférences compatibles,
// b) le bouton pour activer/désactiver la validation automatique d'une règle,
// c) le bouton caché pour activer/désactiver le debugger,
// d) le bouton pour enlever la dernière inférence, et le bouton pour enlever toutes les inférences

// section dédiée au bouton qui permet d'activer ou désactiver la détection des inférences compatibles avec la règle en cours

class InferenceButtonMaker extends Component {
  render() {
    let atLeastOneInference = " deactivated";
    if (this.props.valueInference.allInferencesThemselves.length > 0) {
      // si au moins une inférence est là, les deux boutons deviennent activés,
      // alors qu'ils étaient désactivés par défaut
      atLeastOneInference = " ";
    }

    // bouton pour enlever la dernière inférence, désactivé si aucune inférence n'est là
    let buttonRemoveLastInference = (
        <i
          className={
            "fas fa-long-arrow-alt-left icon pointable" + atLeastOneInference
          }
          onClick={() => {
            this.props.valueInference.removeLastInference();
          }}
          onMouseOver={() => {
            this.props.valueInference.modifyClassNameOfAnyInference(
              "removable",
              "last"
            );
          }}
          onMouseOut={() => {
            this.props.valueInference.modifyClassNameOfAnyInference(
              "unremovable",
              "last"
            );
          }}
        />
      ),
      // bouton pour enlever toutes les inférences, désactivé si aucune inférence n'est là
      buttonEraseAllInferences = (
        <i
          className={"fas fa-eraser icon pointable" + atLeastOneInference}
          onClick={() => {
            this.props.valueInference.resetDeduction();
          }}
          onMouseOver={() => {
            this.props.valueInference.modifyClassNameOfAnyInference(
              "removable",
              "all"
            );
          }}
          onMouseOut={() => {
            this.props.valueInference.modifyClassNameOfAnyInference(
              "unremovable",
              "all"
            );
          }}
        />
      );

    return (
      <React.Fragment>
        {buttonRemoveLastInference}
        {buttonEraseAllInferences}
      </React.Fragment>
    );
  }
}
export default InferenceButtonMaker;



// WEBPACK FOOTER //
// ./src/components/Calcul Tools/Deducer Tools/InferenceButtonMaker.js